// extracted by mini-css-extract-plugin
export default {"root":"Forgot_root__GCvLw","form":"Forgot_form__3Y8dG"};